import { PurchaseStatus } from '../models/enums';
import { Purchase } from '../models/purchase';
import { ConfirmStatus } from '../models/purchase/ConfirmStatus';
import { Receipt } from '../models/receipt';

export class PurchaseConfirmationStatusCalculator {
    public static calculate(purchase: Purchase, receipts: Receipt[]): ConfirmStatus {
        if (purchase.status === PurchaseStatus.CANCELLED) {
            return ConfirmStatus.NOT_APPLICABLE;
        }

        if (purchase.isClosed) {
            return ConfirmStatus.PURCHASE_CLOSED;
        }

        return this.calculateFromReceipts(receipts);
    }

    private static calculateFromReceipts(receipts: Receipt[]): ConfirmStatus {
        let hasInScopeReceipts = false;
        for (const receipt of receipts) {
            if (receipt.isInScopeForConfirmation) {
                hasInScopeReceipts = true;
                if (receipt.requiresConfirmation) {
                    return ConfirmStatus.NOT_CONFIRMED;
                }
            }
        }

        return hasInScopeReceipts ? ConfirmStatus.CONFIRMED : ConfirmStatus.NOT_APPLICABLE;
    }
}
